import { EmailActivityView } from '@client/components/_business/sendgrid/EmailActivityView';
import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Mail } from 'lucide-react';
import { z } from 'zod';

export const Route = createFileRoute('/console/$orgId/configuration/monitoring/email-activity')({
    staticData: {
        breadcrumb: { title: 'Email activity' },
        ui: {
            icon: Mail,
            title: 'Email activity',
            subtitle:
                'Track and monitor email delivery, opens, clicks and other engagement metrics for your organisation',
            menuDescription: 'View email delivery status and logs',
        },
        permissions: ['org:admin'],
    },
    validateSearch: zodValidator(
        z.object({
            email: z.string().optional(),
        }),
    ),
    component: OrgEmailActivity,
});

function OrgEmailActivity() {
    const { orgId } = Route.useParams();
    const searchParams = Route.useSearch();

    return (
        <PageController route={Route}>
            <EmailActivityView orgId={orgId} initialEmail={searchParams.email} />
        </PageController>
    );
}
